// TR
export const locale = {
  general : {
    project_1 : 'Dorinsight',
    project_2 : 'Napolyon',
    save : 'Kaydet',
    edit : 'Düzenle',
    delete : 'Sil',
    cancel : 'İptal',
    update : 'Güncelle',
    close : 'Kapat',
    add : 'Ekle',
    delivery : 'Gönderim',
    report : 'Rapor',
    select : 'Seçim Yap',
    all_right_reserved : 'Tüm Hakları Saklıdır.',
    hi : 'Merhaba',
    user_profile : 'Üye Profili',
    new_message : '{number} yeni mesaj',
    project_1_admin : 'Dorinsight Yetkilisi',
    project_2_admin : 'Napolyon Yetkilisi',
    logout : 'Çıkış Yap',
    my_account : 'Hesabım',
    my_account_text : 'Hesap ayarları ve daha fazlası',
    filter : 'Filtre',
    filter_ : 'Filtrele',
    total : 'Toplam',
    email : 'Email',
    phone : 'Telefon',
    file_upload : 'Dosya Yükle',
    file_upload_placeholder : 'Yüklemek için buraya tıklayın.',
    yes : 'Evet',
    no : 'Hayır',
    clear : 'Temizle',
    list : 'Listele',
    desc : 'Açıklama',
    refresh : 'Yenile',
    import_excel : "Excel'e aktar",
    search_placeholder : 'Arama Yap',
    search : 'Ara',
    detail : 'Detay'
  },
  pagination : {
    show_result: "{total} kayıttan {start} - {end} arasındaki kayıtlar gösteriliyor",
    total_row_count : '{total} kayıt arasından {per_page} kayıt görüntüleniyor.'
  },
  login: {
    header: "Giriş",
    header_text: "Giriş bilgilerinizi giriniz:",
    forgot_password: "Şifremi unuttum",
    forgot_password_header: 'Şifremi Unuttum',
    forgot_password_header_text: 'Şifrenizi yenilemek için Eposta adresinizi giriniz:',
    email_error: 'Geçerli bir Eposta adresi giriniz.',
    password_error: 'Şifrenizi giriniz'
  },
  offers: {
    offers : 'Teklifler',
    offer_status : 'Teklif Durumları',
    edit_offer : 'Teklif Kartını Düzenle',
    report : 'Rapor',
    search : 'Ara',
    search_placeholder : 'Arama Yap',
    is_hidden : 'Gizli Teklifler',
    show : 'Göster',
    offer_carts : 'Teklif Kartları',
  },

  reports: {
    title : 'Raporlar',
    number_of_click : 'Tıklama Sayısı',
    number_of_read : 'Okuma Sayısı',
    send_report_title : 'Gönderim Raporu',
    click_report_title : 'Tıklama Raporu',
    read_report_title : 'Okuma Raporu',
    age_report_title : 'Yaş Raporu',
    city_report_title : 'Şehir Raporu',
    gender_report_title : 'Cinsiyet Raporu',
    ses_report_title : 'Ses Raporu',
  },
  new_offer: {
    new_offer_text : 'Yeni Teklif Kartı Oluştur',
    project_name_ : 'Proje Adı:',
    project_name : 'Proje Adı',
    project_name_description : 'Proje için bir ad giriniz.',
    offer_owner_ : 'Teklif Sahibi:',
    customer_ : 'Müşteri:',
    add_new_customer : 'Yeni Müşteri Ekle',
    country_ : 'Ülke:',
    country : 'Ülke:',
    researchs : 'Araştırma Tipleri',
    research_ : 'Araştırma Tipi:',
    order_date : 'Teklif Tarihi',
    order_date_ : 'Teklif Tarihi:',
    contact : 'Kontak',
    contact_ : 'Kontak:',
    sector : 'Sektör',
    sector_ : 'Sektör:',
    currencies : 'Para Birimleri',
    currency_ : 'Para Birimi:',
    exchange_rate_ : 'Kur:',
    learn : 'Öğren',
    note : 'Not',
    customer_name : 'Müşteri Adı',
    customer_name_desc : 'Yeni bir müşteri adı giriniz.',
    project_type : 'Proje Tipi',
    product_type : 'Ürün Tipi',
    customer_type : 'Müşteri Tipi',
    things_to_do : 'Yapılacaklar',
    wave : 'Wawe',
    show_offer : 'Tekliflerde Göster',
    project_status : 'Proje Durumu',
    potential_for_sale : 'Satışa Dönme İhtimali',
    ir : 'IR',
    loi : 'LOI',
    sample : 'Örneklem',
    unit_price : 'Birim Fiyat',
    total_price : 'Toplam Fiyat',
    general_price : 'Genel Toplam',
    ops_cost : 'Ops Maliyeti',
    information : 'Bilgiler',
    field_information : 'Saha Bilgileri',
    offer_type : 'Teklif Türü',

  },
  offer_delivery: {
    cart_info : 'Kart Bilgileri',
    cart_info_desc : 'Kart detaylarını güncelle',
    profiling : 'Profilleme',
    profiling_desc : 'Gönderim profili oluştur',
    design : 'Tasarım',
    design_desc : 'Gönderim tasarımını güncelle',
    delivery : 'Gönderim',
    delivery_desc : 'Gönder ve sonuçları önizle',
    cart_name : 'Kart Adı',
    last_action_date : 'Son İşlem Tarihi',
    survey_score_title : 'Anket Puanı',
    survey_score_text : 'Doldurunca nap kazansın',
    project : 'Proje',
    participants : 'Participants',
    completion : 'Tamamlama',
    screen_out : 'Screen Out',
    cup : 'Kupa',
    survey_information : 'Anket Bilgileri',
    special_links : 'Özel Bağlantılar',
    special_areas : 'Özel Alanlar',
    random_point : 'Random Puan',
    random_point_question : 'Random Puan Verilsin mi?',
    number_of_people : 'Kişi Sayısı',
    extra_points : 'Ekstra Puan',
    profile_fullness : 'Ankete başlamadan önce profil doluluğunu kontrol et.',
    profile_fullness_desc : 'Bu seçildiğinde SES, yaş, cinsiyet ve şehir bilgilerinde eksiklik olan üyeler ankete başlamadan önce bilgi güncelleme sayfasına yönlendirilir.',
    live_pool : 'Canlı Anket',
    next : 'SONRAKİ',
    prev : 'ÖNCEKİ',
    projects : 'Projeler',
    id_match : 'ID EŞLEME',
    voter_id_match : 'VOTER ID EŞLEME',
    deliveries : 'Gönderimler',
    delivery_excluding : 'Gönderim Hariç Tutma',
    user_excluding : 'Üy Hariç Tutma',
    id_upload : 'ID Yükleme',
    results : 'Sonuçlar',
    include_exclude : 'Dahil / Hariç Tutma',
    options : 'Seçenekler',
    voter_guid_upload : 'Voter Guid Yükleme',
    member_id_upload : 'Member ID Yükleme',
    search_options : 'Arama Seçenekleri',
    apply : 'Uygula',
    apply_template : 'Şablon Uygula',
    show_all_template : 'Bütün Şablonları Göster',
    reset : 'Sıfırla',
    template : 'Şablon',
    preview : 'Önizleme',
    links : 'Bağlantılar',
    warnings : 'Uyarılar',
    real_deliveries : 'Gerçek Gönderimler',
    action : 'İşlem',
    start : 'Başlat',
    stop : 'Durdur',
    edit : 'Düzenle',
    show_loaded_data : 'Yüklenen Verileri Göster',
    copy_backup_emails : 'Yüklenen Emailleri Kopyala',
    show_profiling : 'Profillemeyi Göster',
    create_a_reminder : 'Okumayanlara hatırlatma Gönderimi Oluştur',
    refresh : 'Yenile',
    incomplete_a_reminder : 'Tamamlanmayanlara Hatırlatma Gönderimi Oluştur',
    close_project : 'Projeyi Kapat',
    open_project : 'Projeyi Aç',
    show_used_test_ids : "Kullanılan Test ID'lerini Göster",
    list_refno : 'RefNo Listele',
    delete_participation_records : 'Anket Katılım Kayıtlarını Sil',
    internal_test_deliveries : 'İç Test Gönderimleri',
    customer_test_deliveries : 'Müşteri Test Gönderimleri',
    uploaded_data : 'Yüklenen Veriler',
    delivery_reports : 'Gönderim Raporu',
    add_internal_test_post : 'İç Test Gönderimi Ekle',
    add_customer_test_post : 'Müşteri Test Gönderimi Ekle',
    start_time : 'Başlangıç Zamanı',

  },
  profiling : {
    matchType : 'Eşleşme Türü',
    all : 'Dahil',
    any : 'Hariç',
    addRule : 'Kural Ekle',
    addGroup : 'Grup Ekle',

  },
  tests : {
    add_group : 'Yeni Grup Ekle',
    groups : 'Gruplar',
    add : 'Ekle',
    group_name : 'Grup Adı',
    firstname : 'Ad',
    lastname : 'Soyad',
    add_multiple : 'Çoklu Ekle',

  },
  users : {
    member_id : 'Member ID',
    parent_id : 'Parent ID',
    user_id : 'Üye No',
    tc_no : 'T.C. No',
    email : 'Email',
    gsm_no : 'GSM No',
    firstname : 'Ad',
    lastname : 'Soyad',
    cities : 'Şehir',
    start_date : 'Başlangıç Tarihi',
    end_date : 'Bitiş Tarihi',
    search_by_date : 'Tarihe Göre Ara',
    points : {
      point_cup_transaction : 'Puan/Kupa İşlemi',
      point_cup : 'Puan/Kupa',
    }
  },
  user_detail : {
    ref_no : 'Ref No',
    user_information : 'Üye Bilgileri',
    sub_user_information : 'Alt Üye Bilgileri',
    point : 'Puan Bilgileri',
    change_history : 'Değişiklik Tarihçesi',
    photos : 'Fotoğraflar',
    invite : 'Davet',
    contact_us : 'Bize Ulaşın',
    reading_message : 'Mesaj Okuma',
    login_status : 'Login Durumu',
    profile_history : 'Profil Tarihçesi',
    general : 'Genel',
    user_type : 'Üyelik Tipi',
    tc_no : 'T.C. No',
    birth_date: 'Doğum Tarihi',
    firstname : 'Ad',
    lastname : 'Soyad',
    birth_location : 'Doğum Yeri',
    location : 'Oturduğu İl',
    gender : 'Cinsiyet',
    ip_address : 'IP Adresi',
    register_date : 'Kayıt Tarihi',
    iban : 'IBAN Numarası',
    iban2 : 'IBAN 2',
    ses2 : 'Ses-2',
    m_level : 'M-Level',
    stdes : 'StdES',
    altes : 'AltES',
    mail_gsm : 'Mail ve GSM',
    alternative_email : 'Alternatif Email',
    email_preference : 'Email Tercihi',
    email_status : 'Email Statü',
    email_perm_type : 'Email Perm. Type',
    gsm_status : 'GSM Statü',
    gsm_no : 'GSM No',
    gsm_perm_type : 'GSM Perm. Type',
    home_phone : 'Ev Tel',
    gsm_cancel : 'GSM İptal',
    update_gsm : 'GSM Güncelle',
    code_control : 'Kod Kontrol',
    code_area : 'Kod Alanı',
    verification_codes_sent : 'Gönderilen GSM Onay Kodları',
    sent_sms_count : 'Gönderilen SMS Sayısı',
    sent_email_count : 'Gönderilen Email Sayısı',
    member_source : 'Üye Kaynağı',
    sub_user_count : 'Alt Üye Sayısı (1. Derece)',
    active_sub_user_count : 'Aktif Alt Üye Sayısı (1. Derece)',
    bounce_invite_count : 'Bounce Davet Sayısı',
    invite_authorization_code : 'Davet Yetki Durumu (A/K)',
    open_invite_authority : 'Davet Yetkisini Aç',
    facebook_id : 'Facebook ID',
    disconnecting_from_facebook : 'Facebook İlişki Kaldırma',
    address : 'Adres',
    parent_information : 'Parent Bilgileri',
    point_count : 'Puan',
    refresh_information:'Bilgileri Yenile',
    show_image:'Resmi Göster',
    show_unanswered_questions: 'Cevaplanmamış Soruları Getir',
    email_update:'Email Güncelle',
    send_an_activation_email:'Aktivasyon Maili Gönder',
    send_password_sms : 'Şifre Gönder (SMS)',
    answered_questions:'Cevaplanmış Sorular',
    unanswered_questions:'Cevaplanmamış Sorular',
    report : 'Raporla',

  },
  campaigns : {
    message_share : 'Mesaj-Paylaş Kampanyaları',
    add_campaign : 'Yeni Kampanya Ekle',
    edit_campaign: 'Kampanyayı Düzenle',
    campaign_report : 'Kampanya Raporu',
    message_content : 'Mesaj İçeriği',
    confirm : 'Onayla',
    reject : 'Reddet',
    campaign_confirm : 'Kampanya Onaylama',
    message_share_campaign : 'Mesaj-Paylaş Kampanyası'

  },
  menu: {
    delimen: 'Dorinsight',
    actions: 'İşlemler',
    offers: 'Teklifler',
    create_new_offer: 'Teklif Kartı Oluştur',
    create_sample_original: 'Özgün Numune',
    definitions: 'Tanımlar',
    offer_tests: 'İç Test',
    offer_customer_tests: 'Müşteri Testi',
    user_groups: 'Üye Grupları',
    tasks: 'Görevler',
    user_management : 'Üye İşlemleri',
    users : 'Üye Yönetimi',
    content : 'İçerik Yönetimi',
    campaigns: 'Kampanyalar',
    message_share_campaigns : 'Mesaj - Paylaş',
    contact_requests : 'İletişim Talepleri',
    bulk_point_actions : 'Toplu Puan İşlemleri',
    fraud_management : 'Fraud İşlemleri',
    nap_transfer : 'Nap Transferi',
    nap_transfer_campaigns : 'Nap Transfer Kampanyaları',
    promotion_codes : 'Promosyon Kod Havuzu',
    nap_transfer_requests : 'Nap Transfer Talepleri',
  },
  contact_requests : {
    status : 'Durum',
    titles : 'Başlık',
    answers : 'Cevaplar Gösterilsin',
    answer : 'Yanıt',
    reply_to_selected : 'Seçilenleri Yanıtla',
    import_excel : "Excel'e aktar",
    shortcut_messages : 'Hazır Mesajlar'
  },
  bulk_point_actions : {
    id_list : 'ID Listesi',
    bulk_action : 'Toplu İşlem',
    point_action : 'Puan İşlemi',
    point_action_desc : 'Yapmak istediğiniz işlemi seçiniz.',
    point : 'Puan',
    submit : 'İşlemi Gerçekleştir',
    delivery_carts : 'Delivery Kartlar',
    selected_cart_delivery : 'Delivery Kart Seç',
    action_history : 'İşlem Geçmişi'
  },
  fraud_management : {
    get_sub_users : 'Alt Üyeleri Getir',
    groups : 'Gruplama',
    results : 'Sonuçlar'
  },
  nap_transfer : {
    name : 'Nap Transferi',
    add_campaign : 'Transfer Kampanyası Oluştur',
    edit_campaign: 'Kampanyayı Düzenle',
    confirm : 'Onay'
  },
  module: {
    samples: 'Numuneler',
    meeting: 'Toplantı',
    store: 'Depo',
  },
  errors: {
    404: 'Aradığınız sayfa bulunmadı.',
    500: 'İşlem yapılırken hata oluştu.',
    403: 'Bu işlemi yapmaya yetkiniz yok.'
  },
  messages: {
    samples: 'Koleksiyon Numuneleri',
    email: 'E-Posta',
    password: 'Şifre',
    submit: 'Gönder',
    cancel: 'İptal',
    login: 'Giriş',
    send: 'Gönder',
  },
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    DASHBOARD: "Dashboard"
  },
  AUTH: {
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username"
    },
    VALIDATION: {
      INVALID: "{{name}} is not valid",
      REQUIRED: "{{name}} is required",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Selected records count: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    ECOMMERCE: "eCommerce",
    CUSTOMERS: {
      CUSTOMERS: "Customers",
      CUSTOMERS_LIST: "Customers list",
      NEW_CUSTOMER: "New Customer",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Customer Delete",
        DESCRIPTION: "Are you sure to permanently delete this customer?",
        WAIT_DESCRIPTION: "Customer is deleting...",
        MESSAGE: "Customer has been deleted"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Customers Delete",
        DESCRIPTION: "Are you sure to permanently delete selected customers?",
        WAIT_DESCRIPTION: "Customers are deleting...",
        MESSAGE: "Selected customers have been deleted"
      },
      UPDATE_STATUS: {
        TITLE: "Status has been updated for selected customers",
        MESSAGE: "Selected customers status have successfully been updated"
      },
      EDIT: {
        UPDATE_MESSAGE: "Customer has been updated",
        ADD_MESSAGE: "Customer has been created"
      }
    }
  }
};
